import axios from 'axios';
import { ICrudGetAllAction } from 'react-jhipster';

import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';
import { IAllRecord } from 'app/shared/model/allRecord.model';

export const ACTION_TYPES = {
  FETCH_ALL_RECORD_LIST: 'allRecord/FETCH_All_RECORD_LIST',
  RESET: 'allRecord/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IAllRecord>,
};

export type AllRecordState = Readonly<typeof initialState>;

// Reducer

export default (state: AllRecordState = initialState, action): AllRecordState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_ALL_RECORD_LIST): {
      return {
        ...state,
        errorMessage: null,
        loading: true,
      };
    }
    case FAILURE(ACTION_TYPES.FETCH_ALL_RECORD_LIST): {
      return {
        ...state,
        errorMessage: action.payload,
        loading: false,
      };
    }
    case SUCCESS(ACTION_TYPES.FETCH_ALL_RECORD_LIST): {
      return {
        ...state,
        entities: action.payload.data,
        loading: false,
      };
    }
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default: {
      return state;
    }
  }
};

const apiUrl = 'api/all-records';

// Actions

export const getEntities: ICrudGetAllAction<IAllRecord> = () => {
  return {
    type: ACTION_TYPES.FETCH_ALL_RECORD_LIST,
    payload: axios.get<IAllRecord>(`${apiUrl}`),
  };
};

export const reset = () => {
  return {
    type: ACTION_TYPES.RESET,
  };
};
